module.exports = __webpack_public_path__ + "static/primer-popover-ae6df82cf29b2f6295a22f74c536196c.png";